import { Col, Divider, Form, Input, Modal, Row, Table } from "antd";
import { BasicFormWrapper, Main } from "../../styled";
import { AddUser } from "../style";
import { Cards } from "../../../components/cards/frame/cards-frame";
import Heading from "../../../components/heading/heading";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { changePassword, checkCanWeDeleteHost, gethostDetail, hostDeleteData } from "../../../redux/manageHost/actionCreator";
import { Link, useNavigate, useParams } from "react-router-dom";
import Column from "antd/lib/table/Column";
import { getConnectedPms } from "../../../redux/managePms/actionCreator";
import HttpStatus from '../../../utility/status.enum';
import Spinner from "../../common/Spinner";
import { Button } from "../../../components/buttons/buttons";
import { stripeDisconnect, stripeInvitation } from "../../../redux/manageStripe/actionCreator";
import { alertModal } from "../../../components/modals/antd-modals";
import Notification from "../../../utility/notification";
import trashicon from "../../../static/img/trash_bin_icon.svg";

const DetailHostConfiguration = ({ isDetails, setTopActionButtons }) => {


    const { backEndPrefix, unsaveMessage, passwordPattern } = global;
    const [spinnerLoader, setSpinnerLoader] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [hostDetail, setHostDetail] = useState([]);
    const { hostSlug } = useParams();
    const [affilateHostDetails, setAffilateHostDetails] = useState([]);
    const refererHosts = [
        { label: 'Referral Host One' },
        { label: 'Referral Host Two' },
    ];

    const hostWaiverDropDown = [
        {
            type: 1,
            option: "Purchase waivers for all guests",
        },
        {
            type: 2,
            option: "Purchase waivers only if the guest selects security hold",
        },
        {
            type: 3,
            option: "Guests choose coverage",
        },
        {
            type: 4,
            option: "Host purchases on Airbnb/Vrbo, Guest chooses on others",
        },
        {
            type: 5,
            option: 'Purchase waivers for all guests, but guests have a required hold',
        },
    ]
    const [pmsDataSource, setPmsDataSource] = useState([]);

    const [dataSource, setDataSource] = useState([]);
    const [isDirty, setIsDirty] = useState(false);
    const [form] = Form.useForm();
    const [state, setState] = useState({
        visible: false,
        modalType: 'primary',
    });


    const utcTimestamp = hostDetail?.stripe_link_at;
    const localTime = utcTimestamp ? new Date(utcTimestamp) : null;
    const timezoneOffsetMinutes = localTime ? localTime.getTimezoneOffset() : 0;

    const localTimeWithOffset = localTime ? new Date(localTime.getTime() - timezoneOffsetMinutes * 60000) : null;

    const stripeLinkAtDate = localTimeWithOffset
        ? localTimeWithOffset.toLocaleDateString('en-US', { year: '2-digit', month: '2-digit', day: '2-digit' })
        : '';
    const stripeLinkAtTime = localTimeWithOffset
        ? localTimeWithOffset.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })
        : '';
    const stripeLinkDateTime = `${stripeLinkAtDate} ${stripeLinkAtTime}`;

    const fetchData = async () => {

        if(!hostSlug) return;
        try {
            setSpinnerLoader(true);
            const response = await dispatch(
                gethostDetail(hostSlug, (response) => {
                    return response;
                }),
            );

            if (response?.status !== HttpStatus.HTTP_OK) {
                navigate(`${backEndPrefix}/host`);
                return;
            }

            setHostDetail(response?.result);
            const responseData = response?.result;
            const partnerCoverageData = responseData?.partner_coverage || [];
            const formatValue = (value, rateType) => {
                return value > 0 ? (rateType === 1 ? `$${Number(value).toLocaleString('en-US')}` : `${Number(value).toLocaleString('en-US')}%`) : '';
            };
            const mappedData = partnerCoverageData.map((item) => ({
                ...item,
                fee: formatValue(item.fee, item.rate_type), // both
                additional_night_fee: formatValue(item.additional_night_fee, item.rate_type), // both
                coverage_limit: item.coverage_limit > 0 ? '$' + Number(item.coverage_limit).toLocaleString('en-US') : "",
                min_additional_night_rate: item.min_additional_night_rate > 0 ? '$' + Number(item.min_additional_night_rate).toLocaleString('en-US') : "",
                mrp: item.mrp > 0 ? '$' + Number(item.mrp).toLocaleString('en-US') : "",
                min_security_hold: item.min_security_hold > 0 ? '$' + Number(item.min_security_hold).toLocaleString('en-US') : "",
                name: item.name,
                plan_name: item?.plan_name,
                on_night_over: item.on_night_over > 0 ? Number(item.on_night_over).toLocaleString('en-US') : "",
                is_default: item.is_default,
                is_airbnb_enable: item.is_airbnb_enable,
                is_low_cost_enable: item.is_low_cost_enable,
                is_vrbo_enable: item.is_vrbo_enable,
                slug: item.slug,
            }));
            setDataSource(mappedData);
            const affiliateHostResponse = responseData?.affiliate_host || [];
            setAffilateHostDetails(affiliateHostResponse);
            global.isShowCardsOnFile = responseData?.is_allowed_card_file ?? global.isShowCardsOnFile;
        } catch (error) { }
        finally {
            setSpinnerLoader(false);
        }
    };

    const getStatusText = (statusId) => {
        switch (statusId) {
            case 1:
                return 'Active';
            case 2:
                return 'Inactive';
            default:
                return '';
        }
    };
    const getStatusClass = (statusId) => {
        switch (statusId) {
            case 1:
                return 'active';
            case 2:
                return 'deactiveted';
            case 3:
                return 'blocked';
            default:
                return '';
        }
    };

    const getChatStatus = (statusId) => {   // chat status 
        switch (statusId) {
            case 1:
                return 'Yes';
            case 2:
                return 'No';
            default:
                return '';
        }
    };

    const getPmsConnectedData = async () => {
        setSpinnerLoader(true);
        const form = {
            host_slug: hostSlug,
            request_type: 2,
        };
        try {
            const connectedPmsData = await dispatch(getConnectedPms(form));
            if (connectedPmsData?.status === HttpStatus.HTTP_OK) {
                const pmsObjData = connectedPmsData?.result?.map((data) => {
                    const { pms_name, properties } = data;
                    const formattedProperties = properties?.map(
                        (property) => `${property.name} (ID: ${property.id})`
                    ).join(', ') || "";

                    return {
                        pms_name,
                        properties: formattedProperties,
                    };
                }) || [];
                setPmsDataSource(pmsObjData);
            }
        }
        catch (error) {
            console.log('Error in createPmsAuth API', error);
        } finally {
            setSpinnerLoader(false);
        }
    };

    const selectedWaiverOption = hostWaiverDropDown.find((option) => {
        return option.type == hostDetail?.payment_type
    })?.option || '';


    useEffect(() => {
        fetchData();
        getPmsConnectedData();
    }, [isDetails]);

    const showChangePassword = () => {
        setState({
            ...state,
            visible: true,
        });
    };

    const onCancel = () => {
        setState({
            ...state,
            visible: false,
        });
    };

    const handleChangePasswordClose = () => {
        if (isDirty) {
            const confirmCancel = window.confirm(unsaveMessage);
            if (!confirmCancel) return;
            setIsDirty(false);
            global.isDirtyGlobal = false;
        }
        form.resetFields(['confirm_password', 'new_password']);
        onCancel();
    };

    const handleInputChange = () => {
        setIsDirty(true);
    };

    const changePasswordSave = (values) => {
        if (!hostSlug) return;
        setSpinnerLoader(true);
        const requestData = { ...values, slug: hostSlug, is_admin_request: 1 };
        const savePassword = async () => {
            try {
                const passwordResponse = await dispatch(
                    changePassword(requestData, (response) => response),
                );
                if (passwordResponse?.status !== HttpStatus.HTTP_OK) {
                    Notification.addNotificationError(passwordResponse.message);
                } else {
                    global.isDirtyGlobal = false;
                    setIsDirty(false);
                    Notification.addNotificationSuccess(passwordResponse.message);
                    form.resetFields(['confirm_password', 'new_password']);
                    onCancel();
                }
            } finally {
                setSpinnerLoader(false);
            }
        };
        savePassword();
    };

    const sendStripeInvitation = () => {
        if (!hostSlug) return;
        setSpinnerLoader(true);
        const requestData = { slug: hostSlug, is_send_email: 1 };
        const stripeInvitationFunction = async () => {
            try {
                const stripeInvitationResponse = await dispatch(
                    stripeInvitation(requestData, (response) => response),
                );
                if (stripeInvitationResponse?.status !== HttpStatus.HTTP_OK) {
                    Notification.addNotificationError(stripeInvitationResponse.message);
                } else {
                    Notification.addNotificationSuccess(stripeInvitationResponse.message);
                }
            } finally {
                setSpinnerLoader(false);
            }
        };
        stripeInvitationFunction();
    };

    const disconnectStripe = () => {
        const stripeDisconnectFunction = async () => {
            setSpinnerLoader(true);
            try {
                const stripeDisconnectResponse = await dispatch(
                    stripeDisconnect({ slug: hostSlug }, (response) => response),
                );
                if (stripeDisconnectResponse?.status === HttpStatus.HTTP_OK) {
                    Notification.addNotificationSuccess(stripeDisconnectResponse.message);
                } else {
                    Notification.addNotificationError(stripeDisconnectResponse.message);
                }
                fetchData();
            } finally {
                setSpinnerLoader(false);
            }
        };
        alertModal.confirm({
            title: 'Do you want to disconnect this host from the attached Stripe account?',
            className: 'confirm_modal delete_listing_modal guest-security-modal',
            okText: "Disconnect",
            cancelText: "Cancel",
            okButtonProps: { className: 'guest-security-button' },
            onOk() {
                if (hostSlug) stripeDisconnectFunction();
            },
            onCancel() { },
        });
    };

    const showDeleteConfirmation = async (slug) => {
        const canBeDelete = await dispatch(checkCanWeDeleteHost(hostSlug, (response) => response));
        if (canBeDelete?.status !== HttpStatus.HTTP_OK) {
            const messageOne = "The host is currently configured to a listing and can’t be deleted.";
            const messageTwo = "Coverage is currently configured to a listing and can’t be deleted.";
            const errorMesssage = canBeDelete?.partner_coverage?.length === 0 ? messageOne : messageTwo;
            Notification.addNotificationError(errorMesssage);
            return;
        }
        alertModal.confirm({
            title: 'Do you want to delete these host?',
            className: 'confirm_modal',
            onOk() {
                setSpinnerLoader(true);
                const deleteHost = async () => {
                    try {
                        const deleteHostResponse = await dispatch(
                            hostDeleteData(slug, (response) => response),
                        );
                        if (deleteHostResponse?.status !== HttpStatus.HTTP_OK) {
                            Notification.addNotificationError(deleteHostResponse.message);
                        } else {
                            Notification.addNotificationSuccess(deleteHostResponse.message);
                            navigate(`${backEndPrefix}/host`);
                        }
                    } finally {
                        setSpinnerLoader(false);
                    }
                };
                deleteHost();
            },
            onCancel() { },
        });
    };

    const stripeButtons = [];
    const canDisconnectStripe = Object.keys(hostDetail)?.length && global.checkPermission('host-stripe-disconnect') && hostDetail.is_allowed_stripe_disconnect;
    const canSendStripeInvite = Object.keys(hostDetail)?.length && global.checkPermission('host-show') && hostDetail.is_stripe_status !== 2;

    if (canDisconnectStripe) {
        stripeButtons.push(
            <Button
                onClick={() => disconnectStripe()}
                className="btn-host-setting"
                shape="circle"
                size="default"
                type="primary"
                key="disconnect-stripe"
            >
               Disconnect Stripe
            </Button>
        );
    }

    if (canSendStripeInvite) {
        stripeButtons.push(
            <Button
                onClick={() => sendStripeInvitation()}
                className="btn-host-setting"
                shape="circle"
                size="default"
                type="primary"
                key="send-stripe-invitation"
            >
                Send Stripe Invitation
            </Button>
        );
    }


    useEffect(() => {
        if (!setTopActionButtons) return;
        setTopActionButtons([
            ...stripeButtons,
            global.checkPermission('host-change-password') && (
                <Button
                    onClick={() => showChangePassword()}
                    className="btn-host-setting"
                    shape="circle"
                    size="default"
                    type="primary"
                    key="change-password"
                >
                    Change Password
                </Button>
            ),
            global.checkPermission('host-delete') && (
                <Button
                    onClick={() => showDeleteConfirmation(hostSlug)}
                    className="trash_icon"
                    shape="circle"
                    size=""
                    type=""
                    key="delete-host"
                >
                    <Link className="trash_button">
                        <img src={trashicon} alt="Delete" />
                    </Link>
                </Button>
            ),
        ].filter(Boolean));

        return () => setTopActionButtons([]);
    }, [hostDetail, setTopActionButtons]);

    return (
        <div className="borderRadius common_fiter_table">
            <Main className="mainBlock">
                <Spinner loader={spinnerLoader} />
                <AddUser>
                    <BasicFormWrapper>
                        <Form form={form} name="contact">
                            <Cards headless className="host_userdetails_card">
                                <Row gutter={15}>
                                    <Col xs={24} md={12} className="d-flex align-items-center ">
                                        <div className="project-modal">
                                            <div className="ninjadash-ticket-date-info__text">
                                                <h4 className="ninjadash-ticket-details__top-title">Name </h4>
                                                <span>{hostDetail?.name || ''}</span>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xs={24} md={12}></Col>
                                    <Col xs={24} md={12}>
                                        <div className="project-modal">
                                            <div className="ninjadash-ticket-date-info__text">
                                                <h4 className="ninjadash-ticket-details__top-title">Custom Upsell Service Fee </h4>
                                                <span>{hostDetail?.platform_service_fee > 0 ? hostDetail.platform_service_fee + '%' : ''}</span>

                                            </div>
                                        </div>
                                    </Col>
                                    <Col xs={24} md={12} className="d-flex align-items-start">
                                       <div className="project-modal"> 
                                            <div className="ninjadash-ticket-date-info__text">
                                                <h4 className="ninjadash-ticket-details__top-title">Theme </h4>
                                                <span>{hostDetail?.theme_info?.theme_title || ''}</span>
                                            </div>
                                        </div>
                                    </Col>
                                    {hostDetail?.group_account_info?.length > 0 && (
                                        <Col xs={24} md={12} className="d-flex align-items-start">
                                            <div className="project-modal">
                                                <div className="ninjadash-ticket-date-info__text">
                                                    <h4 className="ninjadash-ticket-details__top-title">Group Account </h4>
                                                    <span>{hostDetail.group_account_info?.map(item => item.name).join(', ') || ''}</span>
                                                </div>
                                            </div>
                                        </Col>
                                    )}
                                    <Col xs={24} md={12}>
                                        <div className="project-modal">
                                            <div className="ninjadash-ticket-date-info__text">
                                                <h4 className="ninjadash-ticket-details__top-title">Country Name </h4>
                                                <span>{hostDetail?.country_name}</span>
                                            </div>
                                        </div>
                                    </Col>

                                </Row>
                                {hostDetail?.is_stripe_status === 2 && (
                                    <Row gutter={15}>
                                        <Col xs={24} md={12}>
                                            <div className="project-modal">
                                                <div className="ninjadash-ticket-date-info__text">
                                                    <h4 className="ninjadash-ticket-details__top-title">Stripe Account ID </h4>
                                                    <a className='common_urlLink' target='_blank' rel='noopener noreferrer' href={hostDetail?.strip_dashboard_url}>
                                                        <span>{hostDetail?.stripe_account_id || ''}</span>
                                                    </a>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={24} md={12}>
                                            <div className="project-modal">
                                                <div className="ninjadash-ticket-date-info__text">
                                                    <h4 className="ninjadash-ticket-details__top-title">Stripe Linked Time </h4>
                                                    <span>{stripeLinkDateTime || ''}</span>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                )}
                                <Row gutter={15}>


                                    {hostDetail?.domain &&
                                        <Col xs={24} md={12} className="d-flex align-items-start">
                                            <div className="project-modal">
                                                <div className="ninjadash-ticket-date-info__text">
                                                    <h4 className="ninjadash-ticket-details__top-title">Domain Name </h4>
                                                    <span>{hostDetail?.domain || ''}</span>
                                                </div>
                                            </div>
                                        </Col>
                                    }

                                    <Col xs={24} md={12} className="d-flex align-items-start">
                                        <div className="project-modal">
                                            <div className="ninjadash-ticket-date-info__text">
                                                <h4 className="ninjadash-ticket-details__top-title">Status </h4>
                                                <span className={`ninjadash-status ninjadash-status-${getStatusClass(hostDetail?.status_id)}`}>
                                                    {getStatusText(hostDetail?.status_id)}
                                                </span>
                                            </div>
                                        </div>
                                    </Col>

                                    <Col xs={24} md={12}>
                                        <div className="project-modal">
                                            <div className="ninjadash-ticket-date-info__text">
                                                <h4 className="ninjadash-ticket-details__top-title">Chat Enabled </h4>
                                                <span>{getChatStatus(hostDetail?.is_chat_enable)}</span>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                {affilateHostDetails.length > 0 && (
                                    affilateHostDetails.map((refererHost, index) => (
                                        <Row gutter={15}>
                                            <Col xs={24} md={12}>
                                                <div className="project-modal">
                                                    <div className="ninjadash-ticket-date-info__text">
                                                        <h4 className="ninjadash-ticket-details__top-title">{refererHosts[index].label} </h4>
                                                        <span>{refererHost?.name || ''}</span>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col xs={24} md={12}>
                                                <div className="project-modal">
                                                    <div className="ninjadash-ticket-date-info__text">
                                                        <h4 className="ninjadash-ticket-details__top-title">Referral Amount </h4>
                                                        <span>${refererHost?.amount || ''}</span>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    ))
                                )}
                                <Divider className="mt-0"/>
                                <Heading as="h6" className="required-label">
                                    <span className="error require"></span> Waiver Options {' '}
                                </Heading>
                                <Row gutter={15}>
                                    <Col xs={24} md={12} className="d-flex align-items-center ">
                                        <div className="project-modal">
                                            <div className="ninjadash-ticket-date-info__text">
                                                <h4 className="ninjadash-ticket-details__top-title">Select Options </h4>
                                                <span>{selectedWaiverOption}</span>
                                                {/* <span>Test</span> */}
                                            </div>
                                        </div>
                                    </Col>
                                    {
                                        hostDetail?.payment_type !== 3 && (
                                            <>
                                                <Col xs={24} md={12}>
                                                    <div className="project-modal">
                                                        <div className="ninjadash-ticket-date-info__text">
                                                            <h4 className="ninjadash-ticket-details__top-title">Stripe Customer ID </h4>
                                                            <span>{hostDetail?.stripe_customer_id}</span>
                                                        </div>
                                                    </div>
                                                </Col>
                                                {
                                                    hostDetail?.default_payment_method &&
                                                    <Col xs={24} md={12}>
                                                        <div className="project-modal">
                                                            <div className="ninjadash-ticket-date-info__text">
                                                                <h4 className="ninjadash-ticket-details__top-title">Stripe Default Payment Method </h4>
                                                                <span>{hostDetail?.default_payment_method?.card_name}</span>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                }
                                            </>
                                        )
                                    }
                                </Row>
                            </Cards>
                        </Form>
                    </BasicFormWrapper>
                </AddUser>
            </Main>
            <Cards headless className={`coverage_table_card common_fiter_table ${pmsDataSource && pmsDataSource.length > 0 && 'brder-radius-0'}`}>
                <div className="ninjadash-form-action coverage_table_card_action">
                    <Table
                        dataSource={dataSource}
                        pagination={false}
                        rowKey="slug"
                        className="table-responsive coverage-detail-table"
                    >
                        <Column
                            title="Low Cost"
                            key="is_low_cost_enable"
                            render={(text, record) => (record.is_low_cost_enable === 1 ? 'Yes' : 'No')}
                        />
                        <Column
                            title="Airbnb Only"
                            key="is_airbnb_enable"
                            render={(text, record) => (record.is_airbnb_enable === 1 ? 'Yes' : 'No')}
                        />
                        <Column
                            title="Vrbo Only"
                            key="is_vrbo_enable"
                            render={(text, record) => (record.is_vrbo_enable === 1 ? 'Yes' : 'No')}
                        />
                        <Column
                            title="Default"
                            key="is_default"
                            render={(text, record) => (record.is_default === 1 ? 'Yes' : 'No')}
                        />
                        <Column title="Provider" dataIndex="name" key="name" />
                        <Column title="Plan Name" dataIndex="plan_name" key="plan_name" />
                        <Column title="Coverage Limit" dataIndex="coverage_limit" key="coverage_limit" />
                        <Column title="Fee" dataIndex="fee" key="fee" />
                        <Column
                            title="Additional Nightly Fee"
                            dataIndex="additional_night_fee"
                            key="additional_night_fee"
                        />
                        <Column title={[1, 5].includes(hostDetail?.payment_type) ? 'On Nights Over / Nights Per Set' : 'On Nights Over'} dataIndex="on_night_over" key="on_night_over" />
                        <Column title="Min. Retail Price" dataIndex="mrp" key="mrp" />
                        <Column
                            title="Min. Additional Nightly Rate"
                            dataIndex="min_additional_night_rate"
                            key="min_additional_night_rate"
                        />
                        <Column title="Min. Security Hold" dataIndex="min_security_hold" key="min_security_hold" />
                    </Table>
                </div>
            </Cards>
            {pmsDataSource && pmsDataSource.length > 0 && (
                <Cards headless className="coverage_table_card common_fiter_table pms_table_card">
                  <div className="ninjadash-form-action coverage_table_card_action">
                    <Table
                      dataSource={pmsDataSource}
                      pagination={false}
                      rowKey="pms"
                      className="table-responsive coverage-detail-table"
                    >
                      <Column title="PMS" dataIndex="pms_name" key="pms_name" />
                      <Column title="Listings" dataIndex="properties" key="properties" />
                    </Table>
                  </div>
                </Cards>
              )}
            <Modal
                type={state.modalType}
                visible={state.visible}
                title="Change Password"
                footer={null}
                onCancel={handleChangePasswordClose}
                className="modal-md"
                maskClosable={false}
                aria-hidden="false"
            >
                <div className="project-modal">
                    <AddUser>
                        <BasicFormWrapper>
                            <Form form={form} name="changePassword" onFinish={changePasswordSave} onValuesChange={handleInputChange}>
                                <Row gutter={15}>
                                    <Col xs={24} md={24}>
                                        <div className="project-modal">
                                            <Form.Item
                                                label="New Password"
                                                name="new_password"
                                                rules={[
                                                    { required: true, message: 'Please enter new password' },
                                                    { min: 8, message: 'Password must be at least 8 characters long' },
                                                    ({ getFieldValue }) => ({
                                                        validator(_, value) {
                                                            if (!value || value.length < 8) return Promise.resolve();
                                                            const pattern = new RegExp(passwordPattern);
                                                            if (pattern.test(value)) return Promise.resolve();
                                                            return Promise.reject(
                                                                new Error('Password must include uppercase, lowercase, number, and special character'),
                                                            );
                                                        },
                                                    }),
                                                ]}
                                            >
                                                <Input.Password placeholder="Enter new password" tabIndex="1" autoComplete='new_password' />
                                            </Form.Item>
                                        </div>
                                    </Col>
                                    <Col xs={24} md={24}>
                                        <div className="project-modal">
                                            <Form.Item
                                                name="confirm_password"
                                                label="Confirm New Password"
                                                dependencies={['new_password']}
                                                rules={[
                                                    { required: true, message: 'Please enter confirm new password' },
                                                    ({ getFieldValue }) => ({
                                                        validator(_, value) {
                                                            if (!value || getFieldValue('new_password') === value) return Promise.resolve();
                                                            return Promise.reject(
                                                                new Error('The new password and confirmation new password do not match'),
                                                            );
                                                        },
                                                    }),
                                                ]}
                                            >
                                                <Input.Password placeholder="Enter confirm new password" tabIndex="2" autoComplete='confirm_password' />
                                            </Form.Item>
                                        </div>
                                    </Col>
                                </Row>
                                <Row gutter={15} className="mt-20">
                                    <Col xs={24}>
                                        <Button htmlType="submit" size="default" type="dark" shape="circle" key="submit" className="w-100">
                                            {spinnerLoader ? 'Loading...' : 'Save'}
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </BasicFormWrapper>
                    </AddUser>
                </div>
            </Modal>
        </div>
    )
}

export default DetailHostConfiguration;